import httpInstances from '@/api/axiosInstance';

export const exportPreviewApi = {
  async fetchIndexData(url: string, headers?: Record<string, string>) {
    const { data } = await httpInstances.axiosDataInstance.get(url, { headers });
    return data;
  }
};
